import {
  Conference,
  Contact,
  EndUser,
  EndUserAccess,
  EndUserNumber,
  ListEntry,
  Organization,
  QueueAgent,
  ServiceNumber,
  SipTerminal,
  Skill
} from '@gt-api';

export class MockData {
  static login = '9997';
  static organization = 'testorg';

  static get testOrg(): Organization {
    return {
      name: 'Test org',
      id: MockData.organization,
      departments: [
        {id: 1, name: 'underavdeling', parentId: 0, subDepartments: []},
        {
          id: 2,
          name: 'underavdeling',
          parentId: 0,
          subDepartments: [{id: 3, name: 'underavdeling2', parentId: 2, subDepartments: []}]
        }
      ]
    };
  }

  static base64image =
    'R0lGODlhPQBEAPeoAJosM//AwO/AwHVYZ/z595kzAP/s7P+goOXMv8+fhw/v739/f+8PD98fH/8mJl+fn/9ZWb8/PzWlwv///' +
    '6wWGbImAPgTEMImIN9gUFCEm/gDALULDN8PAD6atYdCTX9gUNKlj8wZAKUsAOzZz+UMAOsJAP/Z2ccMDA8PD/95eX5NWvsJCOVNQPtfX/8zM8+' +
    'QePLl38MGBr8JCP+zs9myn/8GBqwpAP/GxgwJCPny78lzYLgjAJ8vAP9fX/+MjMUcAN8zM/9wcM8ZGcATEL+QePdZWf/29uc/P9cmJu9MTDImIN+/r7+/vz8/' +
    'P8VNQGNugV8AAF9fX8swMNgTAFlDOICAgPNSUnNWSMQ5MBAQEJE3QPIGAM9AQMqGcG9vb6MhJsEdGM8vLx8fH98AANIWAMuQeL8fABkTEPPQ0OM5OSYdGFl5jo+Pj/' +
    '+pqcsTE78wMFNGQLYmID4dGPvd3UBAQJmTkP+8vH9QUK+vr8ZWSHpzcJMmILdwcLOGcHRQUHxwcK9PT9DQ0O/v70w5MLypoG8wKOuwsP/g4P/' +
    'Q0IcwKEswKMl8aJ9fX2xjdOtGRs/Pz+Dg4GImIP8gIH0sKEAwKKmTiKZ8aB/f39Wsl+LFt8dgUE9PT5x5aHBwcP+AgP+WltdgYMyZfyywz78AAAAAAAD///' +
    '8AAP9mZv///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC' +
    'H5BAEAAKgALAAAAAA9AEQAAAj/AFEJHEiwoMGDCBMqXMiwocAbBww4nEhxoYkUpzJGrMixogkfGUNqlNixJEIDB0SqHGmyJSojM1bKZOmyop0gM3Oe2liTIS' +
    'KMOoPy7GnwY9CjIYcSRYm0aVKSLmE6nfq05QycVLPuhDrxBlCtYJUqNAq2bNWEBj6ZXRuyxZyDRtqwnXvkhACDV+euTeJm1Ki7A73qNWtFiF+/gA95Gly2CJ' +
    'LDhwEHMOUAAuOpLYDEgBxZ4GRTlC1fDnpkM+fOqD6DDj1aZpITp0dtGCDhr+fVuCu3zlg49ijaokTZTo27uG7Gjn2P+hI8+PDPERoUB318bWbfAJ5sUNFcuG' +
    'RTYUqV/3ogfXp1rWlMc6awJjiAAd2fm4ogXjz56aypOoIde4OE5u/F9x199dlXnnGiHZWEYbGpsAEA3QXYnHwEFliKAgswgJ8LPeiUXGwedCAKABACCN+EA1' +
    'pYIIYaFlcDhytd51sGAJbo3onOpajiihlO92KHGaUXGwWjUBChjSPiWJuOO/LYIm4v1tXfE6J4gCSJEZ7YgRYUNrkji9P55sF/ogxw5ZkSqIDaZBV6aSGYq/' +
    'lGZplndkckZ98xoICbTcIJGQAZcNmdmUc210hs35nCyJ58fgmIKX5RQGOZowxaZwYA+JaoKQwswGijBV4C6SiTUmpphMspJx9unX4KaimjDv9aaXOEBteBqm' +
    'uuxgEHoLX6Kqx+yXqqBANsgCtit4FWQAEkrNbpq7HSOmtwag5w57GrmlJBASEU18ADjUYb3ADTinIttsgSB1oJFfA63bduimuqKB1keqwUhoCSK374wbujvO' +
    'Su4QG6UvxBRydcpKsav++Ca6G8A6Pr1x2kVMyHwsVxUALDq/krnrhPSOzXG1lUTIoffqGR7Goi2MAxbv6O2kEG56I7CSlRsEFKFVyovDJoIRTg7sugNRDGqC' +
    'JzJgcKE0ywc0ELm6KBCCJo8DIPFeCWNGcyqNFE06ToAfV0HBRgxsvLThHn1oddQMrXj5DyAQgjEHSAJMWZwS3HPxT/QMbabI/iBCliMLEJKX2EEkomBAUCxR' +
    'i42VDADxyTYDVogV+wSChqmKxEKCDAYFDFj4OmwbY7bDGdBhtrnTQYOigeChUmc1K3QTnAUfEgGFgAWt88hKA6aCRIXhxnQ1yg3BCayK44EWdkUQcBByEQCh' +
    'FXfCB776aQsG0BIlQgQgE8qO26X1h8cEUep8ngRBnOy74E9QgRgEAC8SvOfQkh7FDBDmS43PmGoIiKUUEGkMEC/PJHgxw0xH74yx/3XnaYRJgMB8obxQW6kL' +
    '9QYEJ0FIFgByfIL7/IQAlvQwEpnAC7DtLNJCKUoO/w45c44GwCXiAFB/OXAATQryUxdN4LfFiwgjCNYg+kYMIEFkCKDs6PKAIJouyGWMS1FSKJOMRB/BoIxY' +
    'JIUXFUxNwoIkEKPAgCBZSQHQ1A2EWDfDEUVLyADj5AChSIQW6gu10bE/JG2VnCZGfo4R4d0sdQoBAHhPjhIB94v/wRoRKQWGRHgrhGSQJxCS+0pCZbEhAAOw==';

  static conferences: Conference[] = [
    {
      id: '1',
      scheduled: new Date(),
      duration: 30,
      owner: '123123',
      pinCode: '111',
      number: '4799887766'
    },
    {
      id: '2',
      scheduled: new Date(new Date().getTime() - 900000),
      duration: 30,
      owner: '123123',
      pinCode: '222',
      number: '4799887766'
    },
    {
      id: '3',
      scheduled: new Date(new Date().getTime() - 300000),
      duration: 30,
      owner: '123123',
      pinCode: '333',
      number: '4799887766'
    }
  ];

  static serviceNumbers: ServiceNumber[] = [
    {number: '4735938008', name: 'Hovednummer', pattern: '1'},
    {number: '4735938062', name: 'Test', pattern: '2'},
    {number: '4735938080', name: 'Hovednummer', pattern: '1'},
    {number: '4757623902', name: 'svargruppe', pattern: '2'},
    {number: '4757623903', name: 'svargruppe', pattern: '2'},
    {number: '4770238780', name: 'Svargruppe', pattern: '2'}
  ];

  static get agents(): QueueAgent[] {
    return [
      {
        login: MockData.login,
        serviceNumber: '123',
        active: true,
        state: 1,
        phoneNumber: '4799999971',
        cid: 0
      },
      {
        login: '9998',
        serviceNumber: '123',
        active: true,
        state: 1,
        phoneNumber: '4799999981',
        cid: 0
      },
      {
        login: '9999',
        serviceNumber: '123',
        active: true,
        state: 0,
        phoneNumber: '4799999991',
        cid: 0
      },
      {
        login: '10000',
        serviceNumber: '123',
        active: false,
        state: 1,
        phoneNumber: '4799100001',
        cid: 0
      }
    ];
  }

  static get endUsers(): EndUser[] {
    const result = [
      {
        id: 1,
        login: MockData.login,
        fullNumber: '4799999971',
        shortNumber: '999',
        firstName: 'first1',
        lastName: 'last1',
        outboundState: 0,
        inboundState: 2,
        absenceId: 0,
        organization: MockData.organization,
        departmentId: 1,
        inboundTriggering: true,
        outboundTriggering: true
      },
      {
        id: 2,
        login: '9998',
        fullNumber: '4799999981',
        firstName: 'first2',
        lastName: 'last2',
        outboundState: 0,
        inboundState: 0,
        absenceId: 30,
        organization: MockData.organization,
        departmentId: 0,
        inboundTriggering: true,
        outboundTriggering: true
      },
      {
        id: 3,
        login: '9999',
        fullNumber: '4799999991',
        firstName: 'first3',
        lastName: 'last3',
        outboundState: 0,
        inboundState: 0,
        absenceId: 10,
        organization: MockData.organization,
        departmentId: 1,
        inboundTriggering: true,
        outboundTriggering: true
      },
      {
        id: 4,
        login: '99971',
        fullNumber: '4792499971',
        firstName: 'first4',
        lastName: 'last4',
        outboundState: 0,
        inboundState: 0,
        absenceId: 1,
        organization: MockData.organization,
        departmentId: 1,
        inboundTriggering: true,
        outboundTriggering: true
      },
      {
        id: 300,
        login: '44444332',
        fullNumber: '4744444332',
        firstName: 'Ola',
        lastName: 'Jensen',
        outboundState: 0,
        inboundState: 1,
        absenceId: 1,
        organization: 'testorg2',
        departmentId: 0,
        inboundTriggering: true,
        outboundTriggering: true
      },
      {
        id: 301,
        login: '33333332',
        fullNumber: '4733333332',
        firstName: 'Per',
        lastName: 'Hansen',
        outboundState: 0,
        inboundState: 0,
        absenceId: 2,
        organization: 'testorg2',
        imageId: 1,
        departmentId: 0,
        inboundTriggering: true,
        outboundTriggering: true
      }
    ];
    return result.map(endUser => {
      endUser['@type'] = 'EndUser';
      return endUser;
    });
  }

  static get contacts(): Contact[] {
    const result = [
      {
        id: 1000,
        fullNumber: '4792499229',
        firstName: 'first1',
        lastName: 'last1',
        departmentId: 1
      },
      {
        id: 1001,
        fullNumber: '4799999981',
        firstName: 'first2',
        lastName: 'last2',
        departmentId: 1,
        organization: MockData.organization
      },
      {
        id: 1002,
        fullNumber: '4799999991',
        firstName: 'first3',
        lastName: 'last3',
        departmentId: 1,
        organization: MockData.organization
      },
      {
        id: 1003,
        fullNumber: '4799100001',
        firstName: 'first4',
        lastName: 'last4',
        departmentId: 1
      }
    ];
    return result.map(contact => {
      contact['@type'] = 'Contact';
      return contact;
    });
  }

  static sipTerminals: SipTerminal[] = [
    {
      oname: MockData.organization,
      login: '99971',
      clientType: 1000
    }
  ];

  static getEndUsers(): EndUser[] {
    return MockData.endUsers.map(c => {
      c['@type'] = 'EndUser';
      return c;
    });
  }

  static getContacts(): Contact[] {
    return MockData.contacts.map(c => {
      c['@type'] = 'Contact';
      return c;
    });
  }

  static getServiceNumbers(): ServiceNumber[] {
    return MockData.serviceNumbers.map(c => {
      c['@type'] = 'ServiceNumber';
      return c;
    });
  }

  static getContactById(id: number): Contact {
    return MockData.contacts.find(contact => contact.id === id);
  }

  static getEndUserById(id: number): EndUser {
    return MockData.endUsers.find(endUser => endUser.id === id);
  }

  static getSmsTemplates(): ListEntry[] {
    return [
      {idx: 0, value: 'this is a test', name: 'test', active: true},
      {idx: 1, value: 'this is a test', name: 'test2', active: true}
    ];
  }

  static getSkillsData(): Skill[] {
    return [
      {
        queueCid: 0,
        serviceNumber: '123'
      },
      {
        queueCid: 0,
        serviceNumber: '1234'
      },
      {
        queueCid: 0,
        serviceNumber: '123456'
      },
      {
        queueCid: 0,
        serviceNumber: '1234567'
      },
      {
        queueCid: 0,
        serviceNumber: '4321'
      },
      {
        queueCid: 0,
        serviceNumber: '54321'
      },
      {
        queueCid: 1,
        serviceNumber: '123'
      }
    ];
  }

  static getEndUserAccessData(): EndUserAccess[] {
    return [
      {number: '4791902156', shortNumber: '2156', numberplanId: 0, oname: this.organization, login: '91902156', category: 1},
      {number: '4791902157', shortNumber: '2157', numberplanId: 0, oname: this.organization, login: '91902156', category: 0}
    ];
  }

  static get terminals(): EndUserNumber[] {
    return [
      {
        organization: 'testorg',
        login: '9997',
        idx: 0,
        fullNumber: '4791902156',
        terminalType: 0,
        prePaid: false,
        trigging: 0,
        state: 0,
        stateChanged: new Date(1528716780000),
        range: false,
        additionalDigits: 0,
        trunkProvider: null,
        trunkId: null,
        enabled: true
      },
      {
        organization: 'testorg',
        login: '9997',
        idx: 1,
        fullNumber: '4791909997',
        terminalType: 0,
        prePaid: false,
        trigging: 0,
        state: 0,
        stateChanged: new Date(1528716780000),
        range: false,
        additionalDigits: 0,
        trunkProvider: null,
        trunkId: null,
        enabled: false
      }
    ];
  }
}
